var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgSupermarket = function SvgSupermarket(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 18,
    viewBox: "0 0 20 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_15614_19887)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M18.1043 4.60255L17.4558 3.19535C17.1113 2.44768 16.3633 1.96875 15.5401 1.96875H4.45994C3.63672 1.96875 2.8887 2.44768 2.54417 3.19535L1.89575 4.60255C1.77203 4.87086 1.70312 5.16955 1.70312 5.48438C1.70312 6.64935 2.5069 7.59375 3.67188 7.59375C4.83685 7.59375 5.78125 6.64935 5.78125 5.48438C5.78125 6.64935 6.72565 7.59375 7.89062 7.59375C9.0556 7.59375 10 6.64935 10 5.48438C10 6.64935 10.9444 7.59375 12.1094 7.59375C13.2743 7.59375 14.2188 6.64935 14.2188 5.48438C14.2188 6.64935 15.1632 7.59375 16.3281 7.59375C17.4931 7.59375 18.2969 6.64935 18.2969 5.48438C18.2969 5.16955 18.228 4.87086 18.1043 4.60255Z",
    stroke: "#919191",
    strokeWidth: 2,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M3.10938 7.47363V16.0312",
    stroke: "#919191",
    strokeWidth: 2,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1.70312 16.0312H18.2969",
    stroke: "#919191",
    strokeWidth: 2,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M16.8906 12.4V7.47363",
    stroke: "#919191",
    strokeWidth: 2,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M6.92188 16.0312V12.3125C6.92188 11.5359 7.55149 10.9062 8.32812 10.9062H9.73438C10.511 10.9062 11.1406 11.5359 11.1406 12.3125V16.0312",
    stroke: "#919191",
    strokeWidth: 2,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_15614_19887"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 20,
    height: 18,
    fill: "white"
  })))));
};
export default SvgSupermarket;